import React, { useState } from "react";
import LoadingButton from "../../dumb/LoadingButton";
import DisplayError from "../../dumb/DisplayError";
import useStatusThunk from "../../../hook/useStatusThunk";
import GlossarySelect from "./../projectManager/GlossarySelect";
import { assignGlossaryToProject, assignGlossaryToTitle } from "../../../redux/ducks/glossary";
import useModal from "../../../hook/useModal";

const AssignGlossaryToTitle = props => {
    const [show, hide, renderModal] = useModal();
    const [d_assignGlossaryToTitle, t_status, t_error, t_event] = useStatusThunk(assignGlossaryToTitle);
    const [d_assignGlossaryToProject, p_status, p_error, p_event] = useStatusThunk(assignGlossaryToProject);

    const [selectedGlossaryID, setSelectedGlossaryID] = useState();

    const onSuccess = () => {
        hide();
        setSelectedGlossaryID(null);
    }

    t_event.onSuccess = onSuccess;
    p_event.onSuccess = onSuccess;

    const assign = () => {
        if (props.titleID != undefined) {
            d_assignGlossaryToTitle({ glossaryID: selectedGlossaryID, titleID: props.titleID });
        } else if (props.projectID != undefined) {
            d_assignGlossaryToProject({ glossaryID: selectedGlossaryID, projectID: props.projectID });
        }
    }

    return (
        <React.Fragment>
            <button className={"button button--glossary " + props.className} onClick={show}>Assign Glossary</button>

            {renderModal(
                <React.Fragment>
                    <div className="group">
                        <div className="label">Glossary Name</div>
                        <GlossarySelect onChange={e => setSelectedGlossaryID(e.target.value)} />
                    </div>

                    <div className="group">
                        <DisplayError error={t_error} />
                    </div>

                    <div className="group">
                        <DisplayError error={p_error} />
                    </div>

                    <LoadingButton loading={t_status == "pending" || p_status == "pending"} className="button--glossary" onClick={assign}>Assign Glossary</LoadingButton>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default AssignGlossaryToTitle;